const subContentSearchFieldForm = {
    collectionsText: {
        description: '',
        elementType: 'listSearch',
        elementConfig: {
            type: 'text',
            placeholder: 'find folder'
        },
        value: '',
        selectedValue: 'all',
        validation: {
            required: false,
            isListSearch: true
        },
        valid: false,
        touched: false
    },
    analysesText: {
        description: '',
        elementType: 'listSearch',
        elementConfig: {
            type: 'text',
            placeholder: 'find folder'
        },
        value: '',
        selectedValue: 'all',
        validation: {
            required: false,
            isListSearch: true
        },
        valid: false,
        touched: false
    },
    networkSearchText: {
        description: '',
        elementType: 'listSearch',
        elementConfig: {
            type: 'text',
            placeholder: 'find container or transformation'
        },
        value: '',
        selectedValue: '',
        validation: {
            required: false,
            isListSearch: true
        },
        valid: false,
        touched: false
    }
};

export default subContentSearchFieldForm;